import $ from "jquery"
import Ext from "Ext"
import _ from 'underscore'
import CustomerProjectSelectorPanel from "./at_customer_project_selector_panel"
import messageResource from "../messageResource"
import CoarseSelection from "../enums/CoarseSelection"
import StringIndex from '../util/StringIndex'
import TreeRootNode from '../hierarchySelector/tree/TreeRootNode'
import TreeNodeSet from '../hierarchySelector/tree/TreeNodeSet'
import ArchivedCustomersParentNodeRenderer from '../hierarchySelector/customerProjectSelector/ArchivedCustomersParentNodeRenderer'
import TreeNode from '../hierarchySelector/tree/TreeNode'
import ArchivedProjectsParentNodeRenderer from '../hierarchySelector/customerProjectSelector/ArchivedProjectsParentNodeRenderer'
import CPSelectorTreeBuilder from './CPSelectorTreeBuilder'
import SwitcherWithWrapper from '../components/SwitcherWithWrapper'
import {escapeHtmlSymbols, makeMapAndOrderForEntitiesArray} from '../atUtils'
import {projectNameLower} from '../util/pluralizeUtils'
import ReportsCPSelectorFilter from './ReportsCPSelectorFilter'
import ReportsCPSelectorTreeBuilderObserver from './ReportsCPSelectorTreeBuilderObserver'
import TwoLevelSelection from '../controls/selectorControls/two_level_selection'
import HierarchySelectorUtil from '../controls/selectorControls/hierarchy_selector_util'
import ProjectNodeRenderer from '../hierarchySelector/customerProjectSelector/ProjectNodeRenderer'
import CustomerNodeRenderer from '../hierarchySelector/customerProjectSelector/CustomerNodeRenderer'

const CustomerProjectSelectorTwoGenericOptionsPanel = Ext.extend(CustomerProjectSelectorPanel, {

    allActiveItemsOptionValue: "all_active",
    genericCls: "generic twoGenericOptions",

    allActiveItemsOptionLabelKeyNotFiltered: "projects_customers_selector.all_active_projects_customers",
    allActiveItemsOptionLabelKeyFiltered: "projects_customers_selector.all_active_projects_customers_filtered",
    resetOnHide: false,

    createGenericOptions: function()
    {
        CustomerProjectSelectorTwoGenericOptionsPanel.superclass.createGenericOptions.call(this);
        this.genericOptions.push(
            new Ext.form.Radio({
                                   boxLabel: this.getAllActiveItemsMessage(),
                                   name: this.realOptionsName,
                                   inputValue: this.allActiveItemsOptionValue
                               })
        );
    },

    getCustomOptionSection: function() {
        let customOptionControls = [];
        customOptionControls.push(new Ext.form.Label({
            cls: "reportsCpSelectorLabel",
            text:messageResource.getMessage("report.common.cp_selector.header")
        }))
        customOptionControls.push(this.getCustomOptionButtonsSection())
        this.customControlsContainer = new Ext.Container({
            cls: "cpSelectorCustomControlsContainer",
            autoEl: "div",
            items: customOptionControls
        })

        return [this.customOption, this.customControlsContainer]
    },

    getCustomOptionButtonsSection: function() {
        return new Ext.Panel({
            cls: "buttonsPanel ",
            autEl: "div",
            items: this.getCustomOptionButtons()
        })
    },

    getCustomOptionButtons: function() {
        let buttons = [
            this.filterButton, this.makeVerticalSeparator(),
            this.hideNonSelectedButton, this.makeVerticalSeparator(),
            this.selectAllButton, this.makeVerticalSeparator(),
            this.clearButton
        ]

        if (this.canExpandCollapseNodes()) {
            buttons.push(this.makeVerticalSeparator(), this.collapseAllButton, this.expandAllButton)
        }

        return buttons.reverse()
    },

    getDescription: function(selectionHelper, dropdownButtonId) {
        if (this.manageScopeOnly) {
            const nodeSet = this.selectorFilter.getVisibleNodeSet(this.getSelectedNodeSet())
            const mapping = {
                [TreeNode.TYPE_PROJECT]: TwoLevelSelection.SECOND_LEVEL_INDEX
            }
            const selection = HierarchySelectorUtil.makeSelectionFromNodeSet(nodeSet, true, mapping, 4).getSecondLevel()

            if (selection.length === 0) {
                return messageResource.getEscapedMessage("projects_customers_selector.no_customers_projects_selected")
            } else if (selection.length === 1) {
                return selectionHelper.getSingleItemText(selection[0], false)
            } else if (selection.length > 1) {
                const itemNoun = escapeHtmlSymbols(projectNameLower(selection.length))
                return selection.length + " " + itemNoun
            }
        }

        return selectionHelper.getDescription(this.getSelection(true), dropdownButtonId, true);
    },

    buildCpTree: function(predefinedState) {
        $('.customerProjectType .treePanel').empty()

        // TODO: List of projects, returned by the server, should be sorted by customer name than by project name.
        // TODO: This way we can avoid conversion of customers from array to map. See also RetrieveCustomersProjectsServiceImpl
        let data = makeMapAndOrderForEntitiesArray(this.initData.customers)

        this.rootNode = new TreeRootNode()
        this.searchIndex = new StringIndex()
        this.allActiveSet = new TreeNodeSet()
        new CPSelectorTreeBuilder(
            this.rootNode,
            this.initData.projects,
            data.map,
            data.order,
            this.showEmptyCustomers,
            this.createCpSelectorTreeBuilderObserver(this.searchIndex, this.allActiveSet)).buildTree()
        this.createSelectorTree()
        this.buildSelectorTree()
        this.fireSelectionChangeAllowed = false
        let state = !!predefinedState ? predefinedState : this.getPredefinedSelectionCallback()

        this.fireSelectionChangeAllowed = true
        this.showInactive = state.showInactive;
        this.setInitialOptionValue(this.getOptionValueByStateValue(state.optionValue));
        this.loadPermanentState(state);
        this.setSelection(state.selection);
        this.updateState();

        if (this.showShowInactiveCheckbox) {
            let anyArchived = _.any(this.initData.customers, function(c) { return c.archived })
                              || _.any(this.initData.projects, function(p) { return p.archived })
            if (!anyArchived) {
                this.showInactiveCheckbox.hide()
            }
        }
    },

    buildSelectorTree: function() {
        this.selectorTree.getSelectionController().resetSelectedNodes()
        this.selectorTree.buildDOM(this.treePanel, this.selectorFilter)
        this.treePanel.className = this.getTreePanelClasses().join(" ")
        this.setAlreadyShown()
        this.updateState()
        this.disableTextSelectionForNeededElements()
        this.fireSelectionChangeAllowed = true
    },

    initializeSelector: function(initData, predefinedState) {
        this.enableControls()
        if (initData) this.initData = initData

        let needShowAllNodes = initData.entirelyManageable || initData.allProjectsManageable || initData.allCustomersManageable

        let state = !!predefinedState ? predefinedState : this.getPredefinedSelectionCallback()
        this.buildCpTree(state)
        this.setInitialOptionValue(this.getOptionValueByStateValue(state.optionValue));
        if (this.showInactiveCheckbox && !state.forceHideInactive && this.isCheckShowArchivedCheckboxNeeded(state)) {
            this.showInactiveCheckbox.setChecked(true)
            state.showInactive = true
        }
        this.manageScopeOnly = state.manageScopeOnly
        this.setPredefinedParameters(state)
        this.loadState(state)

        if (!needShowAllNodes && initData.manageable) {
            let $container = $(this.el.dom).find('.custom')
            $container.addClass('withScopeSwitcher')

            let switcherText = messageResource.getMessage('report.common.cp_selector.scope_switcher')
            this.managementScopeSwitcher = new SwitcherWithWrapper({
                containerAdditionalClass: 'scopeSwitcherContainer',
                switcherTextAdditionalClass: "scopeSwitcherText",
                switcherAdditionalClass: "scopeSwitcher",
                onSwitchCallback: (show) => this.showOnlyManageScope(show),
                switcherText: switcherText,
            }).init($container)

            this.showOnlyManageScope(this.manageScopeOnly)
        }
    },

    toggleScopeSwitcher(show) {
        $('.scopeSwitcherContainer').toggle(show)
    },

    showOnlyManageScope: function(enabled) {
        let state = this.getState()
        this.manageScopeOnly = enabled
        if (this.managementScopeSwitcher)
            this.managementScopeSwitcher.setState({enabled})
        this.selectorFilter.setShowOnlyManageable(enabled)
        this.fireChangeEvent()
    },

    isShowOnlyManagementScope: function() {
        return this.manageScopeOnly
    },

    getAllActiveItemsMessage: function()
    {
        return messageResource.getEscapedMessage(
            this.isCustomersProjectsFiltered ? this.allActiveItemsOptionLabelKeyFiltered :
            this.allActiveItemsOptionLabelKeyNotFiltered);
    },

    getOptionValueByStateValue: function(stateValue) {
        switch(stateValue)
        {
            case CoarseSelection.ALL:
                return this.allItemsOptionValue;
            case CoarseSelection.SPECIFIC:
                return this.customOptionValue;
            default:
                return this.allActiveItemsOptionValue;
        }
    },

    getStateValueByOptionValue: function(optionValue) {
        switch(optionValue)
        {
            case this.allItemsOptionValue:
                return CoarseSelection.ALL;
            case this.customOptionValue:
                return CoarseSelection.SPECIFIC;
            default:
                return CoarseSelection.ALL_ACTIVE;
        }
    },

    getNodeRenderers: function() {
        let selectionHelper = this.getSelectionHelper()

        let result = {}
        result[TreeNode.TYPE_CUSTOMER] = new CustomerNodeRenderer(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback(), selectionHelper)
        result[TreeNode.TYPE_PROJECT] = new ProjectNodeRenderer(this.selectorTree, this.selectorFilter, selectionHelper)
        result[TreeNode.TYPE_ARCHIVED_PROJECTS_PARENT] = new ArchivedProjectsParentNodeRenderer(this.selectorTree, this.selectorFilter, selectionHelper)
        result[TreeNode.TYPE_ARCHIVED_CUSTOMERS_PARENT] = new ArchivedCustomersParentNodeRenderer(this.selectorTree, this.selectorFilter, selectionHelper)
        return result
    },

    setPredefinedParameters: function(state) {
        this.predefinedParameters = state
    },

    loadState: function(state) {
        if (this.isAlreadyShown()) {
            this.manageScopeOnlyInit = state.manageScopeOnly
            CustomerProjectSelectorTwoGenericOptionsPanel.superclass.loadState.call(this, state);
        }
    },

    resetState: function() {
        this.showOnlyManageScope(this.manageScopeOnlyInit)
        CustomerProjectSelectorTwoGenericOptionsPanel.superclass.loadState.call(this, this.predefinedParameters)
    },

    createCpSelectorTreeBuilderObserver: function(searchIndex, allActiveSet)
    {
        this.treeBuilderObserver = new ReportsCPSelectorTreeBuilderObserver({
            searchIndex,
            allActiveSet,
            searchCustomers: true
        })

        return this.treeBuilderObserver
    },

    setSelectorFilter: function() {
        this.selectorFilter = new ReportsCPSelectorFilter({
            tree: this.selectorTree,
            searchIndex: this.searchIndex,
            allActiveSet: this.allActiveSet,
            projectsWithMaSet: this.treeBuilderObserver.getProjectsWithMaNodesSet(),
            accessibleCustomersSet: this.treeBuilderObserver.getAccessibleCustomerNodesSet(),
            showOnlyManageable: this.manageScopeOnly
        })
    },
});

export default CustomerProjectSelectorTwoGenericOptionsPanel;


// WEBPACK FOOTER //
// ./web/js/cp_selector/at_customer_project_two_generic_options_panel.js